import React, { 
  useRef,
  useState, 
  useEffect 
} from 'react';
import { generateBackground } from '../utils/utils'
import { motion } from "framer-motion"

import {
  Segment,
} from 'semantic-ui-react';

export default function ContentAnimatedScroller(props) {
  //console.log('ContentAnimatedScroller - props', props);

  const {
    bag,
    direction,
  } = props;

  //const textColor = props.text_color ? props.text_color : props.header_text_color ? props.header_text_color : null;

  //process items to fill screen area and setup for Loop animation
  const outerRef = useRef(null);
  const itemRef = useRef(null);
  const defaults = {
    itemWidth: 200,
    itemGap: 25,
    itemCount: bag.contentItems.length,
  }
  const [scrollingItemsState, setScrollingItemsState] = useState([...bag.contentItems]);
  const [scrollingConfigState, setScrollingConfigState] = useState({
    complete: false,
    itemWidth: defaults.itemWidth,
    itemCount: defaults.itemCount,
    calcWidthDiffMinItemsNumber: 0,
    itemsCalc: direction === 'normal' ? [0, -(defaults.itemWidth + defaults.itemGap) * defaults.itemCount] : [-(defaults.itemWidth + defaults.itemGap) * defaults.itemCount, 0],
    duration: defaults.itemCount + 25,
  });
  useEffect(() => {
    const scrollerInit = () => {
      if (scrollingConfigState.complete === false) {
        const outerRefWidth = outerRef.current.getBoundingClientRect().width;
        const itemRefsWidth = itemRef.current.getBoundingClientRect().width;
        const calcWidthDiffMinItemsNumber = Math.ceil(outerRefWidth / itemRefsWidth);
        //console.debug('scrollerInit', {outerRefWidth, itemRefsWidth, calcWidthDiffMinItemsNumber});
        if (scrollingItemsState.length < calcWidthDiffMinItemsNumber) {
          //console.debug('scrollerInit - need more items to fill width');
          //find diff
          const calcNumItemsToAdd = calcWidthDiffMinItemsNumber - scrollingItemsState.length;
          //console.debug('scrollerInit - calcNumItemsToAdd', calcNumItemsToAdd);
          //select items to add
          let itemsToAdd = []
          for (const item of scrollingItemsState) {
            if (itemsToAdd.length !== calcNumItemsToAdd) {
              itemsToAdd = [...itemsToAdd, item]
            }
          }
          //console.debug('scrollerInit - itemsToAdd', itemsToAdd);
          const filledScrollingItems = [...scrollingItemsState, ...itemsToAdd, ...scrollingItemsState, ...itemsToAdd];
          setScrollingItemsState(filledScrollingItems);
          setScrollingConfigState({
            ...scrollingConfigState,
            complete: true,
            itemWidth: itemRefsWidth,
            calcWidthDiffMinItemsNumber,
            itemCount: filledScrollingItems.length,
          });
        } else {
          //console.debug('scrollerInit - enough items to fill width');
          const filledScrollingItems = [...scrollingItemsState, ...scrollingItemsState, ];
          setScrollingItemsState(filledScrollingItems);
          setScrollingConfigState({
            ...scrollingConfigState,
            complete: true,
            itemWidth: itemRefsWidth,
            calcWidthDiffMinItemsNumber,
            itemCount: filledScrollingItems.length,
          });
        }
      }
    }
    scrollerInit();
  }, [scrollingItemsState, scrollingConfigState]);
  //console.debug('scrollingItemsState', scrollingItemsState);
  //console.debug('scrollingConfigState', scrollingConfigState);
  
  return (
    <>
      <div className={'site-content-scrolling'}>
        <motion.ul ref={outerRef}
          transition={{ duration: scrollingConfigState.duration, ease: 'linear', repeat: Infinity, repeatType: "loop"  }}
          //transition={{ duration: scrollingConfigState.duration, ease: 'linear', repeat: Infinity, repeatType: "loop"  }}
          initial={{ x: 0 }}
          animate={{ x: scrollingConfigState.itemsCalc }}
        >
          {scrollingItemsState.map((item, i) => {
            const itemBackground = generateBackground(null, item.image);
            return (
              <li key={i} ref={itemRef}
                //transition={{ duration: 5, ease: 'linear', repeat: Infinity, repeatType: "loop"  }}
                //initial={{ x: 0 }}
                //animate={{ x: scrollingConfigState.itemsCalc }}
              >
                <Segment basic>
                  <div className={'image'} style={{ background: itemBackground, }}></div>
                  {/* {i} */}
                </Segment>
              </li>
            )
          })}
        </motion.ul>
      </div>
    </>
  )
}